import { render } from "./ProjectEditPortfolioTracker.vue?vue&type=template&id=63037e8b&scoped=true"
import script from "./ProjectEditPortfolioTracker.vue?vue&type=script&lang=js"
export * from "./ProjectEditPortfolioTracker.vue?vue&type=script&lang=js"

import "./ProjectEditPortfolioTracker.vue?vue&type=style&index=0&id=63037e8b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63037e8b"]])

export default __exports__